export const TYPES = {
  SET_DEFAULT_SUPPORTER_ALL: "default_supporter/SET_DEFAULT_SUPPORTER_ALL",
  SET_DEFAULT_SUPPORTER_OPEN_ADD:
    "default_supporter/SET_DEFAULT_SUPPORTER_OPEN_ADD",
  SET_DEFAULT_SUPPORTER_OPEN_EDIT:
    "default_supporter/SET_DEFAULT_SUPPORTER_OPEN_EDIT",
  SET_DEFAULT_SUPPORTER_SELECTED:
    "default_supporter/SET_DEFAULT_SUPPORTER_SELECTED",
  SET_DEFAULT_SUPPORTER_SEARCH:
    "default_supporter/SET_DEFAULT_SUPPORTER_SEARCH",
  SET_DEFAULT_SUPPORTER_INFO: "default_supporter/SET_DEFAULT_SUPPORTER_INFO",
  SET_DEFAULT_SUPPORTER_TYPE: "default_supporter/SET_DEFAULT_SUPPORTER_TYPE",
};
